import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 21 29">
    <g id="Page-1">
      <g id="New-Streaming-Device-Icon">
        <path
          id="Shape"
          style={{ fill: color }}
          d="M17.9,11.5c-1.3-1.2-2.9-2.2-4.7-2.6V0.4c0-0.2-0.2-0.4-0.4-0.4H8.2C7.9,0,7.8,0.2,7.8,0.4v8.5
			C6,9.3,4.4,10.2,3.1,11.5C1.2,13.3,0,15.9,0,18.7c0,2.8,1.2,5.3,3.1,7.2c1.9,1.8,4.5,3,7.4,3c2.9,0,5.5-1.1,7.4-3
			c1.9-1.8,3.1-4.4,3.1-7.2C21,15.9,19.8,13.3,17.9,11.5z M8.5,0.7h4v8c-0.6-0.1-1.3-0.2-2-0.2s-1.3,0.1-2,0.2V0.7z M17.4,25.3
			c-1.8,1.7-4.2,2.8-6.9,2.8c-2.7,0-5.1-1.1-6.9-2.8c-1.8-1.7-2.9-4.1-2.9-6.7c0-2.6,1.1-5,2.9-6.7c1.3-1.2,2.8-2.1,4.6-2.5
			c0,0,0,0,0,0C9,9.3,9.7,9.2,10.5,9.2c0.8,0,1.5,0.1,2.3,0.3c0,0,0,0,0,0c1.8,0.4,3.4,1.3,4.6,2.5c1.8,1.7,2.9,4.1,2.9,6.7
			C20.3,21.3,19.2,23.6,17.4,25.3z"
        />
        <path
          id="Shape_1_"
          style={{ fill: color }}
          d="M15,14.3c-1.1-1.1-2.7-1.8-4.5-1.8c-1.7,0-3.3,0.7-4.5,1.8c-0.3,0.3-0.5,0.5-0.7,0.9
			c0,0,0,0,0,0c-0.7,1-1.1,2.2-1.1,3.4c0,1.7,0.7,3.2,1.9,4.3c1.1,1.1,2.7,1.8,4.4,1.8c0,0,0,0,0,0c0,0,0,0,0,0
			c1.7,0,3.3-0.7,4.5-1.8c1.1-1.1,1.9-2.6,1.9-4.3C16.8,17,16.1,15.4,15,14.3z M6.6,14.8c1-1,2.4-1.6,3.9-1.6s2.9,0.6,3.9,1.6
			c0.3,0.3,0.5,0.5,0.7,0.9l-4.2,0c-0.2,0-0.3,0-0.5,0c-0.8,0-1.6,0.3-2.2,0.9c-0.3,0.3-0.6,0.7-0.7,1.1L6,15.4
			C6.2,15.2,6.4,15,6.6,14.8z M12.1,17.1c0.4,0.4,0.7,1,0.7,1.6c0,0.6-0.2,1.1-0.6,1.5c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1
			c-0.4,0.4-1,0.7-1.6,0.7c-0.6,0-1.2-0.3-1.6-0.7c-0.4-0.4-0.7-1-0.7-1.6v0c0-0.6,0.3-1.2,0.7-1.6c0.4-0.4,1-0.7,1.6-0.7
			c0.1,0,0.3,0,0.4,0c0,0,0,0,0,0C11.4,16.5,11.8,16.7,12.1,17.1z M4.9,18.7c0-0.9,0.2-1.8,0.7-2.6l1.8,2.7c0,0.8,0.4,1.5,0.9,2
			c0.6,0.5,1.3,0.9,2.2,0.9c0.4,0,0.7-0.1,1.1-0.2l-1.3,2.6c-1.5-0.1-2.8-0.6-3.7-1.6C5.5,21.5,4.9,20.2,4.9,18.7z M14.4,22.5
			c-0.9,0.8-2,1.4-3.3,1.6l1.7-3.4c0.5-0.5,0.7-1.2,0.7-1.9c0-0.8-0.3-1.6-0.9-2.1c0,0-0.1-0.1-0.1-0.1l3.1,0
			c0.3,0.7,0.5,1.4,0.5,2.3C16.1,20.2,15.5,21.5,14.4,22.5z"
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/NewStreamingDeviceIcon.js